import React from "react";
import {useHistory} from "react-router-dom";
import {loginFragments} from "./style";
import {Images} from "utils";

export const LoginHeader = () => {
    const classes = loginFragments();
    const history = useHistory()

    const handleChangePage = () => {
        history.push('/')
    }

    return (
        <div className={classes.LoginHead}>
            <div>
                <p style={{cursor:'pointer'}} onClick={handleChangePage}>PoloTMS</p>
            </div>

            <div className={classes.LoginHeadPhoneNumber}>
                <a href={`tel:+15623910015`}>
                    <img src={Images.phone} alt={"Phone"}/>
                    <span>(562) 391-0015</span>
                </a>
            </div>
        </div>
    );
};
